// @flow
import React from "react";

import ErrorBoundary from "../../global/containers/ErrorBoundary";
import { LightTheme } from "../../global/uis/themes";
import MobileMenu from "../../global/containers/MobileMenu";
import Menu from "../../global/containers/Menu";

import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import Hidden from "@material-ui/core/Hidden";

const Template = (props: *): * => {
  return (
    <MuiThemeProvider theme={LightTheme}>
      <ErrorBoundary>
        <div className="app-wrapper mui-form">
          <Hidden mdUp>
            <MobileMenu />
          </Hidden>
          <Menu>{props.children}</Menu>
        </div>
      </ErrorBoundary>
    </MuiThemeProvider>
  );
};

export default Template;
